module.exports = __webpack_public_path__ + "static/media/atr.3e6e6d8d.jpeg";